import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const buoyDevicesApi = createApi({
  reducerPath: 'buoyDevicesApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getBuoyDevices: builder.query({
      query: () => ({
        url: '/v2/integrations/device/buoy/map', //previously /buoyMapData
        method: 'GET',
        data: undefined,
        params: undefined,
        headers: undefined,
        responseType: undefined,
        msAuth: undefined,
      }),
      keepUnusedDataFor: 60 * 15, // Cache for 15 minutes
      transformResponse: (response) => response?.data ?? [],
    }),
  }),
});

export const { useGetBuoyDevicesQuery } = buoyDevicesApi;
